(function () {
  ///////////////////////////////////
  autoplayManager.updateOKButton = function () {
    var canEnable =
      (autoplayManager.stake <= gdk.getBalance() ||
        gdk.allowSpinIfNotEnoughCredit()) &&
      autoplayManager.lossLimitSet;

    autoplayManager.dialog.OKButton.enableButton(canEnable);

    // only turn ok button green when it's enabled
    autoplayManager.dialog.OKButton.alpha = canEnable ? 1 : 0.5;
    autoplayManager.dialog.OKButtonText.style.fill = canEnable
      ? 0x62e702
      : 0xffffff;
  };

  ///////////////////////////////////
  autoplayManager.onOrientationChange = function () {
    if (autoplayManager.dialog.container.visible) {
      var background = resourceManager.get("autoplayContainer:autoplayBacker");
      background.interactive = true;
      background.visible = true;
    }
  };

  ///////////////////////////////////
  autoplayManager.openDialog = function (
    confirmCallback,
    cancelCallback,
    coinSize,
    numberOfWinlines
  ) {
    // allow background touch to close dialog
    var background = resourceManager.get("autoplayContainer:autoplayBacker");
    background.interactive = true;
    background.visible = true;
    background.mousedown = background.touchstart = autoplayManager.onCancel;

    resourceManager.get(
      "uiContainer:buttonContainer:autoplayButton:glow"
    ).visible = true;

    let self = this;
    Reflex.registerEventHandler("orientationChange", function () {
      self.onOrientationChange();
    });

    // Coins is the cost of playing one winline
    if (coinSize !== undefined) {
      autoplayManager.stake = coinSize * numberOfWinlines;
    }

    var numberOfSpins = autoplayManager.AP.fields.numberOfRounds.values;

    if (!autoplayManager.dialog.numberOFSpinsButtons) {
      autoplayManager.dialog.numberOFSpinsButtons = [];

      var xLeft = -280;
      var xRight = 280;
      var yStart = -10;
      var columns = 5;

      var xGap = (-xLeft + xRight) / (columns - 1);
      var yGap = 60;

      var rowCount = 0;
      var colCount = 0;

      for (let i = 0; i < 10; i++) {
        let button = resourceManager.get(
          "autoplayContainer:autoplayBackground:numberOfSpinsButtonContainer:button" +
            i
        );

        if (rowCount === columns) {
          rowCount = 0;
          colCount++;
        }

        var xPos = xLeft + xGap * rowCount;
        var yPos = yStart + yGap * colCount;

        for (var name in resourceManager.configuration.layouts) {
          if (resourceManager.configuration.layouts[name].mapped) continue;
          button.Props[name].position.x = xPos;
          button.Props[name].position.y = yPos;
        }

        button.position.set(xPos, yPos);

        if (numberOfSpins[i]) {
          button.setButtonText(numberOfSpins[i]);
          button.buttonText.position.set(-2, -5);
          button.buttonText.style.fill = i == 0 ? 0x62e702 : 0xffffff;
          button.enableButton(true);
          button.spinValue = numberOfSpins[i];
          button.nosIndex = i;
          button.onPressedCallback = autoplayManager.onNOSselect;
          autoplayManager.dialog.numberOFSpinsButtons.push(button);
        } else {
          button.enableButton(false);
          button.buttonSprite.visible = false;
          button.setButtonText("");
        }

        rowCount++;
      }
    }

    autoplayManager.lossLimitSet = false;

    autoplayManager.dialog.OKButtonText = resourceManager.get(
      "autoplayContainer:autoplayBackground:autoplayOK:label"
    );

    // default start button to look disabled
    autoplayManager.dialog.OKButton.alpha = 0.5;
    autoplayManager.dialog.OKButtonText.style.fill = 0xffffff;

    autoplayManager.dialog.OKButton.enableButton(false);

    // Fade in dialog
    autoplayManager.dialog.container.visible = true;
    autoplayManager.dialog.container.alpha = 0;
    timerManager.addTimer(
      300,
      autoplayManager.fadeInDialog,
      autoplayManager.fadeInDialogCompete
    );

    autoplayManager.dialog.OKButton.onPressedCallback = function () {};
    autoplayManager.dialog.cancelButton.onPressedCallback = function () {};

    // Store callbacks
    autoplayManager.callbacks.OK = confirmCallback;
    autoplayManager.callbacks.cancel = cancelCallback;

    // Reset autoplay settings
    //autoplayManager.AP.reset();

    autoplayManager.dialog.NOStext.text =
      autoplayManager.AP.fields["numberOfRounds"].currentValue;
    autoplayManager.dialog.LLtext.setTranslationPhrase("t_autoplayPleaseSet");
    autoplayManager.dialog.SWLtext.setTranslationPhrase(
      autoplayManager.getSWLtext()
    );
  };

  ///////////////////////////////////
  autoplayManager.onNOSselect = function () {
    for (
      var i = 0;
      i < autoplayManager.dialog.numberOFSpinsButtons.length;
      i++
    ) {
      autoplayManager.dialog.numberOFSpinsButtons[
        i
      ].buttonText.style.fill = 0xffffff;
    }

    soundManager.play("buttonPressed");

    this.buttonText.style.fill = 0x62e702;

    var data = autoplayManager.AP.fields["numberOfRounds"];
    var newIndex = this.nosIndex;

    autoplayManager.AP.setField("numberOfRounds", data.values[newIndex]);
    autoplayManager.dialog.NOStext.text =
      autoplayManager.AP.fields["numberOfRounds"].currentValue;
    autoplayManager.updateOKButton();
  };

  ///////////////////////////////////
  autoplayManager.fadeOutDialogCancelled = function () {
    var background = resourceManager.get("autoplayContainer:autoplayBacker");
    background.interactive = false;
    background.visible = false;

    resourceManager.get(
      "uiContainer:buttonContainer:autoplayButton:glow"
    ).visible = false;

    autoplayManager.dialog.container.visible = false;

    autoplayManager.dialog.container.alpha = 1;

    autoplayManager.callbacks.cancel();
  };

  ///////////////////////////////////
  autoplayManager.fadeOutDialogAccepted = function () {
    var background = resourceManager.get("autoplayContainer:autoplayBacker");
    background.interactive = false;
    background.visible = false;

    resourceManager.get(
      "uiContainer:buttonContainer:autoplayButton:glow"
    ).visible = false;

    autoplayManager.dialog.container.visible = false;
    autoplayManager.dialog.container.alpha = 1;

    // Now we have left dialog, start autoplay
    autoplayManager.AP.start(autoplayManager.stake);
    autoplayManager.callbacks.OK();
  };

  autoplayManager.onStakeChanged = function () {
    if (autoplayManager.dialog.numberOFSpinsButtons) {
      for (
        var i = 0;
        i < autoplayManager.dialog.numberOFSpinsButtons.length;
        i++
      ) {
        autoplayManager.dialog.numberOFSpinsButtons[
          i
        ].buttonText.style.fill = 0xffffff;
      }
      autoplayManager.dialog.numberOFSpinsButtons[0].buttonText.style.fill = 0x62e702;
    }
  };

  autoplayManager.onModal = function (data) {
    if (autoplayManager.dialog.container.visible && data.reason === undefined) {
      messageBus.post("game:modal", { reason: "Autoplay open" });
    }

    if (data.reason === "Platform Paused") {
      autoplayManager.stopAutoplay();
      gameController.cancelAutoplay();
    }
  };

  autoplayManager.layoutComplete = function () {
    resourceManager.get(
      "uiContainer:buttonContainer:autoplayButton:glow"
    ).visible = false;
  };

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    autoplayManager.layoutComplete
  );
  messageBus.subscribe("stake:stakeChanged", autoplayManager.onStakeChanged);
  messageBus.subscribe("game:modal", autoplayManager.onModal);
})();
